module.exports = __webpack_public_path__ + "img/symbol_arrow2red.8dde788e.png";